/**
 * Demo users for the Assisted eKYC showcase build.
 * Specified in contracts-1 §11.4.
 *
 * These exist only when `environment.useMock` is true. Nothing here reaches a real environment.
 */

export type MockRole = 'MAKER' | 'BRANCH_CHECKER' | 'COGB_CHECKER';

export interface MockUser {
  userIdentity: string;
  username: string;
  password: string;
  role: MockRole;
  roleLabel: string;
  scope: string[];
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  phoneNo: string;
  branchCode: string;
  branchName: string;
}

export const MOCK_USERS: MockUser[] = [
  {
    userIdentity: 'USR-MAKER-001',
    username: 'test-maker',
    password: 'Test@1234',
    role: 'MAKER',
    roleLabel: 'Branch Officer (Maker)',
    scope: ['BROWSE', 'CREATE', 'EDIT'],
    firstName: 'Tanvir',
    lastName: 'Ahmed',
    fullName: 'Tanvir Ahmed',
    email: 'test-maker@nccbank.com.bd',
    phoneNo: '01711000001',
    branchCode: 'BR-0101',
    branchName: 'Motijheel Branch',
  },
  {
    userIdentity: 'USR-CHECKER-001',
    username: 'test-checker',
    password: 'Test@1234',
    role: 'BRANCH_CHECKER',
    roleLabel: 'Branch Checker',
    scope: ['BROWSE', 'AUTHORIZE'],
    firstName: 'Nusrat',
    lastName: 'Jahan',
    fullName: 'Nusrat Jahan',
    email: 'test-checker@nccbank.com.bd',
    phoneNo: '01711000002',
    branchCode: 'BR-0101',
    branchName: 'Motijheel Branch',
  },
  {
    userIdentity: 'USR-COGB-001',
    username: 'test-COGB',
    password: 'Test@1234',
    role: 'COGB_CHECKER',
    roleLabel: 'COGB Checker (Head Office)',
    scope: ['BROWSE', 'AUTHORIZE', 'CREATE', 'EDIT'],
    firstName: 'Rezaul',
    lastName: 'Karim',
    fullName: 'Rezaul Karim',
    email: 'test-cogb@nccbank.com.bd',
    phoneNo: '01711000003',
    branchCode: 'HO-0001',
    branchName: 'Head Office — COGB',
  },
];

/** Case-insensitive on username, exact on password. */
export function findMockUser(username: string, password: string): MockUser | undefined {
  const candidate = MOCK_USERS.find((u) => u.username.toLowerCase() === (username ?? '').trim().toLowerCase());
  return candidate && candidate.password === password ? candidate : undefined;
}

export function findMockUserByUsername(username: string): MockUser | undefined {
  return MOCK_USERS.find((u) => u.username.toLowerCase() === (username ?? '').trim().toLowerCase());
}
